import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const GateAdminDashboardDataSlice = createSlice({
  name: "GateAdminDashboardData",
  initialState: {} as IReduxState<any>,
  reducers: {
    GateAdminDashboardData: (state) => {
      state.isLoading = true;
    },
    successGateAdminDashboardData: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureGateAdminDashboardData: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearGateAdminDashboardData: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureGateAdminDashboardData,
  successGateAdminDashboardData,
  clearGateAdminDashboardData,
  GateAdminDashboardData,
} = GateAdminDashboardDataSlice.actions;

export default GateAdminDashboardDataSlice.reducer;
